// Centralized brand & asset constants for Dent Xpress
export const BRAND = {
  name: "Dent Xpress",
  // Mobile / WhatsApp (WhatsApp uses a separate line)
  phone: "99775383",
  phoneIntl: "+96599775383",
  whatsappNumber: "96555787747",
  whatsappNumberLocal: "55787747",
  whatsappLink: "https://wa.me/96555787747",
  telLink: "tel:+96599775383",
  // Shop landline
  shopPhone: "24837666",
  shopPhoneIntl: "+96524837666",
  shopTelLink: "tel:+96524837666",
  email: "info@dentxpress.com",
  emailLink: "mailto:info@dentxpress.com",
  mapsLink: "https://maps.app.goo.gl/LAfCJJk72dAFhYmR7",
  mapsEmbed:
    "https://www.google.com/maps?q=Shuwaikh%20Industrial%20Kuwait&output=embed",
  instagramLink: "https://instagram.com/dentxpress",
  instagramHandle: "@dentxpress",
  location: "Shuwaikh, Kuwait",
  addressEn: "Nasser Center, Shop 33, Shuwaikh, Kuwait",
  addressAr: "مركز ناصر، محل ٣٣، الشويخ، الكويت",
};

export const LOGO_URL = "/logo.png";

// Uploaded cases. All before/after pairs confirmed by owner.
// Originally-swapped filenames were corrected when mapping — local files are
// named by their real role (before = damaged, after = repaired).
export const CASES = [
  { id: 1, before: "/cases/case-1-before.jpg", after: "/cases/case-1-after.jpg" },
  { id: 2, before: "/cases/case-2-before.jpg", after: "/cases/case-2-after.jpg" },
  { id: 3, before: "/cases/case-3-before.jpg", after: "/cases/case-3-after.jpg" },
  { id: 4, before: "/cases/case-4-before.jpg", after: "/cases/case-4-after.jpg" },
  { id: 5, before: "/cases/case-5-before.jpg", after: "/cases/case-5-after.jpg" },
  { id: 6, before: "/cases/case-6-before.jpg", after: "/cases/case-6-after.jpg" },
  { id: 7, before: "/cases/case-7-before.jpg", after: "/cases/case-7-after.jpg" },
];

// Video-only cases shown in the Repair Results section.
export const VIDEO_CASES = [
  {
    id: 8,
    before: "/cases/case-8-before-video.mp4",
    after: "/cases/case-8-after-video.mp4",
  },
];

// Real 5-star Google reviews in English (verbatim from Google Maps).
export const REAL_REVIEWS_EN = [
  {
    name: "Vivek",
    full: "This guys are the best in what they do, they are really professional. I had around three dents — one medium sized and two small — all cleared in 30 mins. Mr Saleh is really friendly.",
    when: "a year ago",
    rating: 5,
  },
  {
    name: "Guruprasad",
    full: "Excellent work done. Was really happy with the staff. Very cooperative.",
    when: "2 years ago",
    rating: 5,
  },
  {
    name: "Saleh",
    full: "It's a good place to fix your car. Around it lots of places but it's the original and the first to open and offer this service.",
    when: "3 years ago",
    rating: 5,
  },
  {
    name: "Dragos",
    full: "Great experience. Had some doubts when I entered and they said, yes we can fix this dent and this and this, but in the end when they showed me my car and the work done… Speechless. What they promised they delivered. I'd highly recommend to visit them if you have dents, big or small, that you want to fix quickly. And now, after a long time, had to fix again some dents. Same great service and great results.",
    when: "3 years ago",
    rating: 5,
  },
];

// Real 5-star Arabic Google reviews.
// Text reconstructed in natural Kuwaiti Arabic from the original reviews (Maps share
// links expose the English-translated version only). Owner can paste the exact
// verbatim Arabic text here if they want 1:1 wording.
export const REAL_REVIEWS_AR = [
  {
    name: "م. خالد المرشود",
    full: "ماشاء الله تبارك الله شغل ١٠٠٪.",
    when: "قبل ٧ سنوات",
    rating: 5,
  },
  {
    name: "عبدالرحمن الملا",
    full: "أحسن شي فيهم أمانتهم. إذا ما يقدرون يطلعون الضربة يقولون لك صراحة ما تطلع أو نسبة النجاح ٦٠ أو ٧٠٪. والله نادر تلاقي محل بهالوصف.",
    when: "قبل ٦ سنوات",
    rating: 5,
  },
  {
    name: "محمد السنوسي",
    full: "ورشة ممتازة، خاصة للسيارات الألمانية.",
    when: "قبل ٧ سنوات",
    rating: 5,
  },
  {
    name: "وليد عوض",
    full: "إذا عندك ضربة في البودي أو في الباب، دنت إكسبرس أفضل محل تصلّحها فيه. محترفين في تصليح الضربات وبسرعة.",
    when: "قبل ٣ سنوات",
    rating: 5,
  },
];

// Visible hours shown on the site. Updated manually — if you change hours on
// Google Maps, ping us and we mirror them here. A live Maps sync requires the
// paid Google Places API.
export const HOURS = {
  regular: [
    { day: "Sun", ar: "الأحد", open: "08:00", close: "13:00", open2: "16:00", close2: "19:00" },
    { day: "Mon", ar: "الاثنين", open: "08:00", close: "13:00", open2: "16:00", close2: "19:00" },
    { day: "Tue", ar: "الثلاثاء", open: "08:00", close: "13:00", open2: "16:00", close2: "19:00" },
    { day: "Wed", ar: "الأربعاء", open: "08:00", close: "13:00", open2: "16:00", close2: "19:00" },
    { day: "Thu", ar: "الخميس", open: "08:00", close: "13:00", open2: "16:00", close2: "19:00" },
    { day: "Fri", ar: "الجمعة", closed: true },
    { day: "Sat", ar: "السبت", open: "08:00", close: "13:00", open2: "16:00", close2: "19:00" },
  ],
  ramadan: {
    active: false, // flip to true during Ramadan
    slots: [
      { open: "10:00", close: "15:00" },
      { open: "20:00", close: "23:00" },
    ],
  },
  note: {
    en: "Hours mirrored from our Google Maps listing. For the most current hours, check Google Maps.",
    ar: "المواعيد منقولة من صفحة خرائط Google. لأحدث المواعيد يرجى زيارة الخريطة.",
  },
};

// Arabic-Indic digits mapping for case numbers
export const AR_DIGITS = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];
export const toArabicDigits = (n) =>
  String(n)
    .split("")
    .map((c) => (/\d/.test(c) ? AR_DIGITS[Number(c)] : c))
    .join("");
